<template>
  <div>
    <v-data-table
      class="elevation-1"
      :headers="
        headers_distinta.length > 0 ? headers_distinta : headers_distinta_base
      "
      :items="items_distinta_base"
      style="width: 100%"
    >
      <!-- Titolo tabella -->
      <template v-slot:top>
        <v-toolbar class="white--text" color="indigo" dense>
          <v-toolbar-title>Distinta Base</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Quantità realizzabile:
            {{
              qta_realizzabile_autonoma === false
                ? fase_sel.qta_realizzabile == null ||
                  fase_sel.qta_realizzabile == ""
                  ? 0
                  : fase_sel.qta_realizzabile % 1 > 0
                  ? fase_sel.qta_realizzabile.toFixed(2)
                  : fase_sel.qta_realizzabile
                : evalQtaRealizzabile
            }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item="{ item }">
        <tr
          :class="
            item.totale <= item.qta_impegnata && item.totale > 0
              ? 'record_green'
              : item.materiale_sotto_lotto == 1
              ? 'record_pink'
              : ''
          "
          v-if="items_distinta_base[0].cod_articolo !== null"
        >
          <!-- Se sto pescando dagli header dinamici... -->
          <template v-if="headers_distinta.length > 0">
            <td
              v-for="(colonna, i) in headers_distinta.filter(
                (e) =>
                  e.value != 'dettaglio_fisso' &&
                  e.value != 'registra_fisso' &&
                  e.value != 'incrementa_commessa' &&
                  e.value != 'dettaglio' &&
                  e.value != 'registra'
              )"
              :key="i"
              v-show="colonna.value != null"
              style="text-align: left"
            >
              {{
                item[colonna.value] !== null &&
                item[colonna.value] !== undefined &&
                item[colonna.value] !== ""
                  ? item[colonna.value]
                  : "N/D"
              }}
            </td>

            <!-- Bottone di Incrementa Commessa -->
            <td
              v-if="
                headers_distinta.filter((e) => e.value == 'incrementa_commessa')
                  .length > 0
              "
              style="text-align: left"
            >
              <v-btn @click="clickIncrementaCommessa(item)" small>
                <v-icon color="primary">mdi-plus-box-multiple</v-icon>
              </v-btn>
            </td>

            <!-- Bottone dettagli -->
            <td
              v-if="
                headers_distinta.filter((e) => e.value == 'dettaglio').length >
                0
              "
              style="text-align: left"
            >
              <v-btn
                v-if="
                  item.totale - item.qta_prelevata >= 0 &&
                  fase_sel.flag_picking != 1 &&
                  picking_allowed == 1
                "
                @click="dettaglioArticolo(item)"
                small
              >
                <v-icon color="primary">mdi-magnify</v-icon>
              </v-btn>
            </td>

            <!-- Bottone qr code -->
            <td
              v-if="
                headers_distinta.filter((e) => e.value == 'registra').length > 0
              "
              style="text-align: left"
            >
              <v-btn
                color="transparent"
                @click="showPrelievi(item)"
                :disabled="
                  (item.qta_prelevata < item.qta_impegnata &&
                    item.qta_impegnata > 0 &&
                    item.materiale_sotto_lotto == 1) ||
                  item.fabbisogno == 0
                "
                elevation="0"
                fab
                v-if="
                  item.totale - item.qta_prelevata >= 0 &&
                  fase_sel.flag_picking != 1 &&
                  picking_allowed == 1
                "
                x-small
              >
                <DataMatrixReader v-on:detectQrCode="detectQrCode" />
              </v-btn>
            </td>

            <!-- Bottone dettagli fissi -->
            <td
              v-if="
                headers_distinta.filter((e) => e.value == 'dettaglio_fisso')
                  .length > 0
              "
              style="text-align: left"
            >
              <v-btn
                v-if="
                  item.totale - item.qta_prelevata >= 0 && picking_allowed == 1
                "
                @click="dettaglioArticolo(item)"
                small
              >
                <v-icon color="primary">mdi-magnify</v-icon>
              </v-btn>
            </td>

            <!-- Bottone qr code -->
            <td
              v-if="
                headers_distinta.filter((e) => e.value == 'registra_fisso')
                  .length > 0
              "
              style="text-align: left"
            >
              <v-btn
                color="transparent"
                @click="showPrelievi(item)"
                :disabled="
                  (item.qta_prelevata < item.qta_impegnata &&
                    item.qta_impegnata > 0 &&
                    item.materiale_sotto_lotto == 1) ||
                  item.fabbisogno == 0
                "
                elevation="0"
                fab
                v-if="
                  item.totale - item.qta_prelevata >= 0 && picking_allowed == 1
                "
                x-small
              >
                <DataMatrixReader v-on:detectQrCode="detectQrCode" />
              </v-btn>
            </td>
          </template>

          <!-- Se sto pescando dagli header statici... -->
          <template v-else>
            <td
              v-for="(colonna, i) in headers_distinta_base.filter(
                (e) =>
                  e.value != 'incrementa_commessa' &&
                  e.value != 'dettaglio' &&
                  e.value != 'registra'
              )"
              :key="i"
              v-show="colonna.value != null"
              style="text-align: left"
            >
              {{
                item[colonna.value] !== null &&
                item[colonna.value] !== undefined &&
                item[colonna.value] !== ""
                  ? item[colonna.value]
                  : "N/D"
              }}
            </td>

            <!-- Bottone di Incrementa Commessa -->
            <td
              v-if="
                headers_distinta_base.filter(
                  (e) => e.value == 'incrementa_commessa'
                ).length > 0
              "
              style="text-align: left"
            >
              <v-btn small>
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </td>

            <!-- Bottone dettagli -->
            <td
              v-if="
                headers_distinta_base.filter((e) => e.value == 'dettaglio')
                  .length > 0
              "
              style="text-align: left"
            >
              <v-btn
                v-if="
                  item.totale - item.qta_prelevata >= 0 &&
                  fase_sel.flag_picking != 1 &&
                  picking_allowed == 1
                "
                @click="dettaglioArticolo(item)"
                small
              >
                <v-icon color="primary">mdi-magnify</v-icon>
              </v-btn>
            </td>

            <!-- Bottone qr code -->
            <td
              v-if="
                headers_distinta_base.filter((e) => e.value == 'registra')
                  .length > 0
              "
              style="text-align: left"
            >
              <v-btn
                color="transparent"
                @click="showPrelievi(item)"
                :disabled="
                  (item.qta_prelevata < item.qta_impegnata &&
                    item.qta_impegnata > 0 &&
                    item.materiale_sotto_lotto == 1) ||
                  item.fabbisogno == 0
                "
                elevation="0"
                fab
                v-if="
                  item.totale - item.qta_prelevata >= 0 &&
                  fase_sel.flag_picking != 1 &&
                  picking_allowed == 1
                "
                x-small
              >
                <DataMatrixReader v-on:detectQrCode="detectQrCode" />
              </v-btn>
            </td>
          </template>
        </tr>
      </template>
    </v-data-table>

    <!-- Dialog dei dettagli -->
    <v-dialog v-model="dettagli_visible" width="70%">
      <v-card>
        <PickingArticoloLotti
          :ID_COMMESSA="id_commessa_dettaglio_selezionata"
          :DA="this.provenienza"
          :CAMBIO_STATO="this.CAMBIO_STATO"
          :COD_ARTICOLO="this.cod_articolo_selezionato"
          :GESTIONE_LOTTO="this.gestione_lotto_selezionata"
          :ID_ARTICOLO="id_articolo_selezionato"
          :lotto_unico="lotto_unico"
          :NUM_TOT_ARTICOLI="tot_articoli_da_utilizzare"
          @prelievo="valori_di_ritorno_picking"
          @prelievo_singolo="setPrelievoSingolo"
          @go_back="close_dialog_dettaglio_articolo"
          :key="key_picking_articolo_lotti"
        />
      </v-card>
    </v-dialog>

    <!-- Dialog dei prelievi -->
    <v-dialog v-model="prelievi_visible" width="700">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-toolbar-title dense>Prelievo</v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="addComponentePrelevato"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi Prelievo</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-btn @click="prelievi_visible = !prelievi_visible" small>
            <v-icon color="error">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container fluid>
          <v-row justify="center" align="center" class="mx-4">
            <!--<v-col cols="2">
              <v-checkbox
                v-model="componente_extra"
                :label="`Componente extra`"
              ></v-checkbox>
            </v-col>-->
            <v-col cols="3" v-if="componente_extra">
              <v-text-field
                background-color="#ffffff"
                dense
                hide-details
                label="Coefficiente"
                v-model="coefficiente_tmp"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#ffffff"
                dense
                hide-details
                label="Codice Lotto"
                v-model="lotto_tmp"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#ffffff"
                dense
                hide-details
                label="Codice Sottolotto"
                readonly
                v-model="sottolotto_tmp"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <v-text-field
                background-color="#ffffff"
                dense
                :disabled="
                  (lotto_tmp == '' || lotto_tmp == null) &&
                  (sottolotto_tmp == '' || sottolotto_tmp == null)
                "
                hide-details
                label="Numero Pezzi"
                :min="0"
                :max="numero_pezzi_max"
                type="number"
                v-model.number="numero_pezzi_tmp"
              ></v-text-field>
            </v-col>
            <v-col cols="3">
              <div style="border: 1px solid black; font-size: 18px">
                Max Pz Prelevabili: <b>{{ numero_pezzi_max }}</b>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog delle info -->
    <!-- <v-dialog v-model="info_dialog_visible">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          dense
          style="position: sticky; top: 0px; z-index: 1"
        >
          <v-toolbar-title dense>Info</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            @click="info_dialog_visible = !info_dialog_visible"
            color="#ffffff"
            fab
            outlined
            small
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-row></v-row>
      </v-card>
    </v-dialog> -->

    <!-- SNACKBAR -->
    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{
        snackbar_icon
      }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>

      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </div>
</template>

<script>
import DataMatrixReader from "../../TOOLS/DataMatrixReader.vue";
import PickingArticoloLotti from "@/components/PRODUCTION/LOGISTICA/ArticoloLottiPicking.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "DistintaBase",
  components: {
    DataMatrixReader,
    PickingArticoloLotti,
    SnackbarQV,
  },
  props: {
    fase_sel: { type: Object, default: () => {} },
    picking_allowed: { type: Number, default: 1 },
    headers_distinta: { type: Array, default: () => [] },
    items_distinta_base: { type: Array, default: () => [] },
    items_distinta_prelievo: { type: Array, default: () => [] },
    num_min_realizzabile: { type: Number, default: null },
    qta_realizzabile_autonoma: { type: Boolean, default: false },
  },
  computed: {
    evalQtaRealizzabile() {
      // Se non ci sono componenti, ritorno 0.
      if (this.items_distinta_base.length === 0) {
        return 0;
      } else {
        /* Se ci sono componenti, mi calcolo
         * quanto di ciascuno mi permette di produrre. */
        this.items_distinta_base.forEach((e) => {
          e.qta_realizzabile = (e.qta_impegnata - e.qta_prelevata) / e.coeff;
        });

        // Cerco il componente che mi fa produrre di meno...
        let res = this.items_distinta_base[0].qta_realizzabile;
        this.items_distinta_base.forEach((e) => {
          if (e.qta_realizzabile < res) {
            res = e.qta_realizzabile;
          }
        });

        // Ritorno la quantità minima producibile.

        // Se la quantità non è esatta, la approssimo a 2 cifre decimali.
        if (res > 0 && res % 1 > 0) {
          return parseFloat(res).toFixed(2);
        } else {
          // Altrimenti la ritorno normalmente.
          return res;
        }
      }
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      CAMBIO_STATO: 0,
      provenienza: "DistintaBase",
      tipo_prelievo: "prelievo_commessa",
      id_commessa_dettaglio_selezionata: null,
      id_articolo_selezionato: null,
      cod_articolo_selezionato: null,
      gestione_lotto_selezionata: null,
      tot_articoli_da_utilizzare: null,
      qr_code_sel: null,
      coefficiente_tmp: 0,
      componente_extra: false,
      id_lotto_tmp: null,
      key_picking_articolo_lotti: 0,
      lotto_tmp: "",
      id_magazzino_tmp: null,
      lotto_unico: -1,
      sottolotto_tmp: "",
      numero_pezzi_tmp: 0,
      numero_pezzi_max: 0,
      dettagli_visible: false,
      prelievi_visible: false,
      info_dialog_visible: false,
      row_sel: null,
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      // array dettaglio lotto
      lotto_dettaglio: [],

      // Modal
      overlay: false,

      // Array
      headers_distinta_base: [
        { text: "Quantità BOM", sortable: false, value: "coeff" },
        { text: "Codice Componente", sortable: false, value: "cod_articolo" },
        {
          text: "Descrizione Componente",
          sortable: false,
          value: "des_articolo",
        },
        { text: "Quantità Totale", sortable: false, value: "totale" },
        { text: "Quantità Impegno", sortable: false, value: "qta_impegnata" },
        { text: "Quantità Fabbisogno", sortable: false, value: "fabbisogno" },
        { text: "Quantità Prelevata", sortable: false, value: "qta_prelevata" },

        { text: "Dettaglio", sortable: false, value: "dettaglio" },
        { text: "Prelievo", sortable: false, value: "registra" },
      ],
      headers_dettaglio: [
        { text: "Cod. Lotto", sortable: false, value: "cod_lotto" },
        { text: "Cod. Articolo", sortable: false, value: "cod_articolo" },
        { text: "Lotto Fornitore", sortable: false, value: "lotto_fornitore" },
        { text: "Giacenza", sortable: false, value: "giacenza" },
      ],
    };
  },
  watch: {
    numero_pezzi_tmp: {
      immediate: true,
      handler() {
        if (this.numero_pezzi_tmp > this.numero_pezzi_max) {
          this.numero_pezzi_tmp = this.numero_pezzi_max;
        }
      },
    },
  },
  methods: {
    addComponentePrelevato() {
      // Controllo che non ci siano troppi pezzi prelevati.
      if (this.numero_pezzi_tmp > this.numero_pezzi_max) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Quantità massima prelevabile: ${this.numero_pezzi_max}.`
        );
        return;
      }

      // Controllo che non ci siano troppo pochi pezzi prelevati.
      if (this.numero_pezzi_tmp < 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Il prelievo non può essere negativo.`
        );
        return;
      }

      // Controllo che i componenti esterni abbiano il coefficiente assegnato.
      if (
        (this.componente_extra === true && this.coefficiente_tmp > 0) ||
        (this.componente_extra === false && this.coefficiente_tmp === 0) ||
        (this.componente_extra === false && this.coefficiente_tmp == null)
      ) {
        // Controllo che i campi siano valorizzati
        if (
          (this.lotto_tmp != "" || this.sottolotto_tmp != "") &&
          this.numero_pezzi_tmp > 0
        ) {
          // Se è tutto a posto, segno i dati del prelievo in un oggetto
          let componente_prelevato = {
            id_articolo: this.row_sel.id_articolo,
            id_lotto: this.id_lotto_tmp,
            cod_lotto: this.lotto_tmp,
            id_magazzino: this.id_magazzino_tmp,
            numero_seriale: this.sottolotto_tmp,
            qta_prelevata: this.numero_pezzi_tmp,
            coeff: this.coefficiente_tmp,
          };

          /* Emetto un evento così il padre usa questi dati
           * per effettuare una chiamata al BE. */
          this.$emit("prelievo_registrato", componente_prelevato);
          this.id_lotto_tmp = null;
          this.id_magazzino_tmp = null;
          this.lotto_tmp = null;
          this.sottolotto_tmp = null;
          this.numero_pezzi_tmp = 0;
          this.numero_pezzi_max = 0;
          this.coefficiente_tmp = null;

          this.prelievi_visible = false;
        } else {
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text =
            'Entrambi i campi "Codice Lotto" e "Numero Pezzi" devono essere valorizzati.';
          this.snackbar_text_color = "white";
        }
      } else {
        this.snackbar = true;
        this.snackbar_background = "error";
        this.snackbar_icon = "mdi-close";
        this.snackbar_icon_color = "white";
        this.snackbar_text =
          "Il coefficiente dei componenti extra deve essere superiore a 0.";
        this.snackbar_text_color = "white";
      }
    },
    clickIncrementaCommessa(arg) {
      // Controllo che ci sia una quantità di campionatura.
      if (arg.qta_campionatura == null || arg.qta_campionatura === "") {
        this.$refs.SnackbarQV.print(
          "orange",
          "Campionatura non impostata o non necessaria."
        );
        return;
      }

      const cod_header_tmp = this.headers_distinta.filter(
        (h) => h.value == "incrementa_commessa"
      )[0].fields;

      this.overlay = true;
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setqueryevent",
          token: localStorage.user_token,
          codice: cod_header_tmp,
          tipo: "post",
          params: [
            { name: "id_commessa", value: this.fase_sel.id_commessa },
            { name: "qta_campionatura", value: arg.qta_campionatura },
          ],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$emit("setqueryevent");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare i dati."
          );
        });
    },
    detectQrCode(
      snackbar_text,
      snackbar_background,
      snackbar_icon,
      snackbar_icon_color,
      snackbar_text_color
    ) {
      //stringa qrcode in snackbar_text
      this.snackbar_text = "QR CODE rilevato";
      this.snackbar = true;
      this.snackbar_background = snackbar_background;
      this.snackbar_icon = snackbar_icon;
      this.snackbar_icon_color = snackbar_icon_color;
      this.snackbar_text_color = snackbar_text_color;

      this.qr_code_sel = snackbar_text;

      this.getQrPrelievo(this.qr_code_sel);
    },
    getQrPrelievo(arg) {
      let richiesta = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getqrprelievo",
          token: localStorage.user_token,
          qr_code: arg,
          id_articolo: this.row_sel.id_articolo,
        },
      };
      this.$store
        .dispatch("api", richiesta)
        .then((res) => {
          if (res.status === 200) {
            if (res.data[0].quantita == 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Questo lotto risulta esaurito."
              );
              return;
            }

            res.data.forEach((e) => {
              this.lotto_tmp = e.cod_lotto;
              this.id_magazzino_tmp = e.id_magazzino;
              this.sottolotto_tmp = e.numero_seriale;
              this.numero_pezzi_tmp = e.quantita;
              this.numero_pezzi_max = e.quantita;
              this.id_lotto_tmp = e.id_lotto;
              this.prelievi_visible = true;
            });
          } else {
            this.snackbar = true;
            this.snackbar_background = "error";
            this.snackbar_icon = "mdi-close";
            this.snackbar_icon_color = "white";
            this.snackbar_text = "QR CODE non valido.";
            this.snackbar_text_color = "white";
          }
        })
        .catch((err) => {
          console.error(err);
          this.snackbar = true;
          this.snackbar_background = "error";
          this.snackbar_icon = "mdi-close";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Errore di comunicazione col server.";
          this.snackbar_text_color = "white";
        });
    },
    valori_di_ritorno_picking(value) {
      //value è argomento passato come ritorno contenete l'array con i codici lotto e la quantità prelevate in funzione della selezione
      //richiamo il padre allo stesso modo di
      //addComponentePrelevato effettundo un ciclo di richieste per tutti i cod lotto e ricaricando la pagina al termine sempre passando dal padre
      // rifacendo la chiamata della distinta base.

      value.forEach((elem) => {
        // debugger;
        if (elem.qta_prelevata > 0 && elem.cod_lotto != null) {
          let componente_prelevato = {
            cod_lotto: elem.cod_lotto,
            qta_prelevata: elem.qta_prelevata,
            coeff: null,
          };
          // Si blocca perché il cod è null
          this.$emit("prelievo_multiplo", componente_prelevato);
        }
      });

      this.$emit("ricarica_pagina");
      this.dettagli_visible = false;
    },
    dettaglioArticolo(item) {
      /* Se l'articolo non ha il magazzino predefinito,
       * blocco tutto perché il magazzino predefinito è
       * una precondizione imprescindibile per continuare. */
      if (item.magazzino_predefinito == null) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Indicare un magazzino predefinito per questo articolo."
        );
        return;
      }

      // Se la riga cliccata è un componente principale...
      if (
        item.materiale_sotto_lotto == 1 &&
        this.items_distinta_prelievo.filter(
          (elem) =>
            elem.id_componente == item.id_articolo &&
            elem.quantita_impegno > elem.quantita_prelevato
        ).length > 0
      ) {
        this.lotto_unico = this.items_distinta_prelievo.filter(
          (elem) =>
            elem.id_componente == item.id_articolo &&
            elem.quantita_impegno > elem.quantita_prelevato
        )[0].id_lotto;
      } else {
        this.lotto_unico = -1;
      }

      this.CAMBIO_STATO = Math.round(Math.random() * 100);
      this.id_articolo_selezionato = item.id_articolo;
      this.cod_articolo_selezionato = item.cod_articolo;
      this.gestione_lotto_selezionata = item.gestione_lotto;
      this.tot_articoli_da_utilizzare = item.fabbisogno;
      this.id_commessa_dettaglio_selezionata =
        this.fase_sel.id_commessa_dettaglio;
      this.dettagli_visible = true;
      this.key_picking_articolo_lotti =
        this.key_picking_articolo_lotti == 0 ? 1 : 0;
    },
    close_dialog_dettaglio_articolo() {
      this.dettagli_visible = false;
      this.CAMBIO_STATO = Math.round(Math.random() * 100);
    },
    showPrelievi(item) {
      this.row_sel = Object.assign({}, item);
    },
    // chiamata per il dettaglio lotto magazzino
    getGiacenzaArticolo(arg) {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getgiacenzaarticolo",
          token: localStorage.getItem("user_token"),
          id_articolo: arg.id_articolo,
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.lotto_dettaglio = res.data;
      });
    },
    setPrelievoSingolo(item, quantita_selezionata) {
      if (
        (quantita_selezionata > 0 && item.cod_lotto != null) ||
        (quantita_selezionata > 0 && item.numero_seriale != null) ||
        item.gestione_lotto == 0
      ) {
        let componente_prelevato = {
          id_articolo: item.id_articolo,
          id_magazzino: item.id_magazzino,
          cod_lotto: item.cod_lotto ? item.cod_lotto : null,
          id_lotto: item.id_lotto ? item.id_lotto : null,
          numero_seriale: item.numero_seriale ? item.numero_seriale : null,
          qta_prelevata: quantita_selezionata,
          coeff: null,
        };
        this.$emit("prelievo_multiplo", componente_prelevato);
      } else {
        this.snackbar = true;
        this.snackbar_background = "error";
        this.snackbar_icon = "mdi-close";
        this.snackbar_icon_color = "white";
        this.snackbar_text =
          "Articolo privo di lotto e sottolotto. Impossibile proseguire con il prelievo.";
        this.snackbar_text_color = "white";
      }

      this.$emit("ricarica_pagina");
      this.dettagli_visible = false;
    },
  },
};
</script>

<style>
.record_green {
  background-color: #6ef579ad !important;
}
.record_green:hover {
  background-color: #6ef579dd !important;
}

.record_pink {
  background-color: #f0a0bf94 !important;
}
.record_pink:hover {
  background-color: #f0a0bfaf !important;
}
</style>
